import React from "react";
import { Route } from "react-router-dom";
import MainInspection from "../Views/Web/Inspection/MainInspection";
import {
  CalendarCreate,
  CalendarEdit,
  CalendarView,
  CalenderMain,
  IndexCalender,
} from "../Views/Web/Inspection/Calender/Index";
import {
  FormOpen,
  FormOpenCerti,
  IndexSchedule,
  NewForm,
  ScheduleCreate,
  ScheduleEdit,
  ScheduleFormView,
  ScheduleMain,
  ScheduleView,
} from "../Views/Web/Inspection/Schedule/Index";
import TaskIndex from "../Views/Web/Inspection/Schedule/IndexTask";
import ViewTask from "../Views/Web/Inspection/Schedule/ViewTask";
import Generator from "../Views/Web/Inspection/Schedule/generator";
import FireFrom from "../Views/Web/FormServ/InspectionForms/FireFrom";
import NewformCerti from "../Views/Web/Inspection/Schedule/NewformCerti";
import GeneratorForm from "../Views/Web/FormServ/InspectionForms/Generator";

function InspectionRoutes() {
  return (
    <Route path="inspection" element={<MainInspection />}>
      <Route path="calender" element={<CalenderMain />}>
        <Route index element={<IndexCalender />} />
        <Route path="create" element={<CalendarCreate />} />
        <Route path="edit/:calenderEditId" element={<CalendarEdit />} />
        <Route path="view/:calenderViewId" element={<CalendarView />} />
      </Route>
      <Route path="schedule" element={<ScheduleMain />}>
        <Route index element={<IndexSchedule />} />
        <Route path="create" element={<ScheduleCreate />} />
        <Route path="edit/:scheduleEditId" element={<ScheduleEdit />} />
        <Route path="view/:scheduleViewId" element={<ScheduleView />} />
        <Route path="index/:scheduleViewId" element={<TaskIndex />} />
        <Route path="viewtask/:scheduleViewId" element={<ViewTask />} />
        <Route path="form/:scheduleViewId" element={<ScheduleFormView />} />
        <Route path="newform/:scheduleViewId" element={<NewForm />} />
        <Route path="generator/:scheduleViewId" element={<Generator />} />
        <Route path="fireProtect/:scheduleViewId" element={<FireFrom />} />
        <Route path="generatorForm/:scheduleViewId" element={<GeneratorForm />} />

        <Route path="certificate/:scheduleViewId" element={<NewformCerti />} />



        <Route path="formOpen/:scheduleViewId" element={<FormOpen />} />
        <Route
          path="formOpenCerti/:scheduleViewId"
          element={<FormOpenCerti />}
        />
      </Route>
    </Route>
  );
}

export default InspectionRoutes;